class InstructionTab extends HTMLElement {
  constructor(){
    super();

    this.tabButtons = this.querySelectorAll('pin-btn');
    this.tabContents = this.querySelectorAll('.tab_ins_item');

    this.tabButtons.forEach(btn => {
      btn.addEventListener('click', this.toggleTab.bind(this))
    })
  }

  toggleTab(event){
    const target = event.target.getAttribute('data-target');
    const deferredMedia = document.querySelector('.deferred-media_' + target);
    
    this.tabButtons.forEach(item => {
      item.closest('.pin_button_content').classList.remove('active')
    });    
    this.tabContents.forEach(item => item.classList.remove('active'));

    event.target.closest('.pin_button_content').classList.add('active');
    document.querySelector('.' + target).classList.add('active');

    // video play function
    window.pauseAllMedia();
    deferredMedia.loadContent(true);
    this.loadVideo(deferredMedia);
  }

  loadVideo(selector) {
    const video = selector.querySelector("video");
    if (!video) return;

    const promise = video.play();
    if (promise !== undefined) {
      promise
        .then(() => {
          // Autoplay started
        })
        .catch((error) => {
          // Autoplay was prevented.
          video.muted = true;
          video.play();
        });
    }
  }
}

customElements.define('pinstruction-details', InstructionTab);